import {
  LayoutDashboard,
  ListTodo,
  Truck,
  Contact,
  Boxes,
  Sparkles,
  BookOpen,
  Bot,
  UserCircle
} from 'lucide-react';

/**
 * Sidebar configuration for the seller (in-store employee) portal. Same shape
 * as the admin nav: grouped items with optional `perm` gates that the server
 * enforces anyway. The seller role already carries the permissions below, so
 * tenant scoping limits every view to the assigned store(s).
 */
export const SELLER_NAV = [
  {
    section: 'Operatività',
    items: [
      { to: '/employee', label: 'Dashboard', icon: LayoutDashboard, end: true },
      { to: '/employee/tasks', label: 'Attività', icon: ListTodo, perm: 'tasks:read' },
      { to: '/employee/logistics', label: 'Logistica', icon: Truck, perm: 'logistics:read' }
    ]
  },
  {
    section: 'Clienti',
    items: [
      { to: '/employee/customers', label: 'Clienti & animali', icon: Contact, perm: 'customers:read' }
    ]
  },
  {
    section: 'Catalogo',
    items: [
      { to: '/employee/inventory', label: 'Inventario', icon: Boxes, perm: 'products:read' },
      { to: '/employee/nutrition', label: 'Nutrizione', icon: Sparkles, perm: 'products:read' },
      { to: '/employee/knowledge', label: 'Knowledge base', icon: BookOpen, perm: 'rag:read' }
    ]
  },
  {
    section: 'AI',
    items: [
      { to: '/employee/chat', label: 'Assistente AI', icon: Bot, perm: 'ai:chat' }
    ]
  },
  {
    section: 'Account',
    items: [
      { to: '/employee/account', label: 'Account', icon: UserCircle }
    ]
  }
];
